import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { QcResponseGrid } from 'src/app/shared/models/grid.model';
import { QcMerchantResponse } from 'src/app/shared/models/qcResponse.model';
import {
  Category,
  Club,
  Country,
  Couponset,
  LoyaltyMember,
  MemberStatus,
  PointSource,
  Schema,
  Store,
} from '../models/members-search.models';

export const LoadMemberData = createAction('[Customer Data: Loyalty Members]: Load Member Data');

export const GetCountriesSuccess = createAction(
  '[Customer Data: Loyalty Members]: Get Countries Success',
  props<{ res: Country[] }>(),
);

export const GetCountriesFailed = createAction(
  '[Customer Data: Loyalty Members]: Get Countries Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetSchemasSuccess = createAction(
  '[Customer Data: Loyalty Members]: Get Schemas Success',
  props<{ res: Schema[] }>(),
);

export const GetSchemasFailed = createAction(
  '[Customer Data: Loyalty Members]: Get Schemas Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetStoresSuccess = createAction(
  '[Customer Data: Loyalty Members]: Get Stores Success',
  props<{ res: Store[] }>(),
);

export const GetStoresFailed = createAction(
  '[Customer Data: Loyalty Members]: Get Stores Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetCategoriesSuccess = createAction(
  '[Customer Data: Loyalty Members]: Get Categories Success',
  props<{ res: Category[] }>(),
);

export const GetCategoriesFailed = createAction(
  '[Customer Data: Loyalty Members]: Get Categories Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetPointSourcesSuccess = createAction(
  '[Customer Data: Loyalty Members]: Get Point Sources Success',
  props<{ res: PointSource[] }>(),
);

export const GetPointSourcesFailed = createAction(
  '[Customer Data: Loyalty Members]: Get Point Sources Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetLoyaltyMembersSuccess = createAction(
  '[Customer Data: Loyalty Members]: Get Loyalty Members Success',
  props<{ res: LoyaltyMember[] }>(),
);

export const GetLoyaltyMembersFailed = createAction(
  '[Customer Data: Loyalty Members]: Get Loyalty Members Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetCustomersSuccess = createAction(
  '[Customer Data: Loyalty Members]: Get Customers Success',
  props<{ res: any }>(),
);

export const GetCustomersFailed = createAction(
  '[Customer Data: Loyalty Members]: Get Customers Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetCouponsetSuccess = createAction(
  '[Customer Data: Loyalty Members]: Get Couponsets Success',
  props<{ res: Couponset[] }>(),
);

export const GetCouponsetFailed = createAction(
  '[Customer Data: Loyalty Members]: Get Couponsets Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetClubsSuccess = createAction(
  '[Customer Data: Loyalty Members]: Get Clubs Success',
  props<{ res: Club[] }>(),
);

export const GetClubsFailed = createAction(
  '[Customer Data: Loyalty Members]: Get Clubs Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetStatusesSuccess = createAction(
  '[Customer Data: Loyalty Members]: Get Statuses Success',
  props<{ res: MemberStatus[] }>(),
);

export const GetStatusesFailed = createAction(
  '[Customer Data: Loyalty Members]: Get Statuses Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetAttributeCodesSuccess = createAction(
  '[Customer Data: Loyalty Members]: Get Attribute Codes Success',
  props<{ res: QcMerchantResponse }>(),
);

export const GetAttributeCodesFailed = createAction(
  '[Customer Data: Loyalty Members]: Get Attribute Codes Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const MainPanelStatusChanged = createAction(
  '[Customer Data: Loyalty Members]: Main Panel Status Changed',
);

export const LoyaltyPanelStatusChanged = createAction(
  '[Customer Data: Loyalty Members]: Loyalty Panel Status Changed',
);

export const PersonalPanelStatusChanged = createAction(
  '[Customer Data: Loyalty Members]: Personal Panel Status Changed',
);

export const OtherPanelStatusChanged = createAction(
  '[Customer Data: Loyalty Members]: Other Panel Status Changed',
);

export const CardNumberChanged = createAction(
  '[Customer Data: Loyalty Members]: Card Number Changed',
  props<{ cardNumber: string }>(),
);

export const SchemaNameChanged = createAction(
  '[Customer Data: Loyalty Members]: Schema Name Changed',
  props<{ schemaName: number }>(),
);

export const RegistrationDateFromChanged = createAction(
  '[Customer Data: Loyalty Members]: Registration Date From Changed',
  props<{ registrationDateFrom: string }>(),
);

export const RegistrationDateUntilChanged = createAction(
  '[Customer Data: Loyalty Members]: Registration Date Until Changed',
  props<{ registrationDateUntil: string }>(),
);

export const RegistrationDateFromCleared = createAction(
  '[Customer Data: Loyalty Members]: Registration Date From Cleared',
);

export const RegistrationDateUntilCleared = createAction(
  '[Customer Data: Loyalty Members]: Registration Date Until Cleared',
);

export const RegistrationStoreChanged = createAction(
  '[Customer Data: Loyalty Members]: Registration Store Changed',
  props<{ registrationStore: number }>(),
);

export const MemberCategoryChanged = createAction(
  '[Customer Data: Loyalty Members]: Member Category Changed',
  props<{ memberCategory: number }>(),
);

export const LastNameChanged = createAction(
  '[Customer Data: Loyalty Members]: Last Name Changed',
  props<{ lastName: string }>(),
);

export const FirstNameChanged = createAction(
  '[Customer Data: Loyalty Members]: First Name Changed',
  props<{ firstName: string }>(),
);

export const EmailChanged = createAction(
  '[Customer Data: Loyalty Members]: Email Changed',
  props<{ email: string }>(),
);

export const MobileChanged = createAction(
  '[Customer Data: Loyalty Members]: Mobile Changed',
  props<{ mobile: string }>(),
);

export const CountryChanged = createAction(
  '[Customer Data: Loyalty Members]: Country Changed',
  props<{ country: number }>(),
);

export const MemberTagChanged = createAction(
  '[Customer Data: Loyalty Members]: Member Tag Changed',
  props<{ memberTag: number }>(),
);

export const ClubChanged = createAction(
  '[Customer Data: Loyalty Members]: Club Changed',
  props<{ club: number }>(),
);

export const QivosIDChanged = createAction(
  '[Customer Data: Loyalty Members]: Qivos ID Changed',
  props<{ qivosID: string }>(),
);

export const AttributeTypeChanged = createAction(
  '[Customer Data: Loyalty Members]: Attribute Type Changed',
  props<{ attributeType: string }>(),
);

export const AttributeNameChanged = createAction(
  '[Customer Data: Loyalty Members]: Attribute Name Changed',
  props<{ attributeName: string }>(),
);

export const AttributeValueChanged = createAction(
  '[Customer Data: Loyalty Members]: Attribute Value Changed',
  props<{ attributeValue: string | number }>(),
);

export const BoolAttributeValueChanged = createAction(
  '[Customer Data: Loyalty Members]: Bool Attribute Value Changed',
);

export const AttributeDateFromChanged = createAction(
  '[Customer Data: Loyalty Members]: Attribute Date From Changed',
  props<{ attributeDateFrom: string }>(),
);

export const AttributeDateUntilChanged = createAction(
  '[Customer Data: Loyalty Members]: Attribute Date Until Changed',
  props<{ attributeDateUntil: string }>(),
);

export const ClearAttributeDateFrom = createAction(
  '[Customer Data: Loyalty Members]: Clear Attribute Date From',
);

export const ClearAttributeDateUntil = createAction(
  '[Customer Data: Loyalty Members]: Clear Attribute Date Until',
);

export const IncludeInactiveChanged = createAction(
  '[Customer Data: Loyalty Members]: Include Inactive Changed',
);

export const SearchCustomers = createAction('[Customer Data: Loyalty Members]: Search Customers');

export const SearchCustomersSuccess = createAction(
  '[Customer Data: Loyalty Members]: Search Customers Success',
  props<{ res: QcResponseGrid }>(),
);

export const SearchCustomersFailed = createAction(
  '[Customer Data: Loyalty Members]: Search Customers Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const ClearCustomerFilters = createAction(
  '[Customer Data: Loyalty Members]: Clear Customer Filters',
);

export const SearchLoyaltyMembers = createAction(
  '[Customer Data: Loyalty Members]: Search Loyalty Members',
);

export const SearchCountLoyaltyMembers = createAction(
  '[Customer Data: Loyalty Members]: Search Count Loyalty Members',
);

export const SearchCountLoyaltyMembersSuccess = createAction(
  '[Customer Data: Loyalty Members]: Search Count Loyalty Members Success',
  props<{ res: number }>(),
);

export const SearchCountLoyaltyMembersFailed = createAction(
  '[Customer Data: Loyalty Members]: Search Count Loyalty Members Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const LoyaltyMemberIdChanged = createAction(
  '[Customer Data: Loyalty Members]: Loyalty Member Id Changed',
  props<{ loyaltyMemberId: number }>(),
);
